import React, { Component } from 'react';
import { GameCard } from './GameCard';
import { OfflinePlayerControls } from './OfflinePlayerControls';
import './OfflineGameBoard.css';

export class OfflineGameBoard extends Component {
    static displayName = OfflineGameBoard.name;

  constructor(props) {
      super(props);
      this.gameboardRef = React.createRef();
      this.isCardClickable = this.isCardClickable.bind(this);
      this.getCurrentHintTurn = this.getCurrentHintTurn.bind(this);
      this.reportCardState = this.reportCardState.bind(this);
      this.reportSelectingColor = this.reportSelectingColor.bind(this);
      this.getPhase = this.getPhase.bind(this);
      this.giveHint = this.giveHint.bind(this);
      this.getState = this.getState.bind(this);
      this.concedeTurn = this.concedeTurn.bind(this);
      this.markAllGreensFinishedForHintingPlayer = this.markAllGreensFinishedForHintingPlayer.bind(this);
      this.preventSwipe = this.preventSwipe.bind(this);
      this.state = { words: [], loading: true, turn: 0, countersUsed: 0, maxCounters: props.match.params.turns || 9, phase: "start", greenCount: 0, allGreensFinishedForPlayer: 0, selectedCard: null, isButtonDisabled: false };
  }

  componentDidMount() {
      this.populateWordsData();
      // Add touch event listener to prevent default on swipe
      this.populateWordsData().then(() => {
          // Make sure the element is present
          if (this.gameboardRef.current) {
              this.gameboardRef.current.addEventListener('touchmove', this.preventSwipe, { passive: false });
          }
      });
    }

    componentWillUnmount() {
        // Check if the element is present before trying to remove the event listener
        if (this.gameboardRef.current) {
            this.gameboardRef.current.removeEventListener('touchmove', this.preventSwipe);
        }
    }

    preventSwipe(e) {
        // Prevent scrolling (swiping) but allow tapping (clicking)
        if (e.scale && e.scale !== 1) { // This condition is a simple check for pinch-zooming
            // Do nothing if pinch-zooming
        } else {
            // Prevent default if not pinch-zooming
            e.preventDefault();
        }
    }

    giveHint(player) {
        if (this.state.phase === "start") {
            this.setState({
                phase: "guessing",
                turn: player
            });
        }
    }

    

    isCardClickable() {
        return this.state.phase === "guessing";
    }

    getState() {
        return this.state;
    }

    getCurrentHintTurn() {
        return this.state.turn;
    }

    getPhase() {
        return this.state.phase;
    }

    getCurrentPlayerTurn() {
        return this.state.turn;
    }

    reportCardState(color) {
        if (this.state.phase !== "settingColor")
            return;

        switch (color) {
            case "black":
                this.setState({ phase: "assassinated" });
                return;
            case "green":
                var greenCount = this.state.greenCount + 1;
                this.setState({ greenCount: greenCount });
                if (greenCount >= 15) {
                    this.setState({ phase: "finished" });
                } else {
                    this.setState({ phase: "guessing" });
                }
                return;
            case "yellow":
                this.changeTurn();
                return;
        }
    }

    concedeTurn() {
        if (this.state.phase !== "guessing" || this.state.isButtonDisabled) return;

        this.changeTurn();

        this.setState({ isButtonDisabled: true });
        setTimeout(() => this.setState({ isButtonDisabled: false }), 1000); // 1 second delay
    }

    markAllGreensFinishedForHintingPlayer(player) {
        if (this.state.allGreensFinishedForPlayer != 0)
            return;
        this.setState({ allGreensFinishedForPlayer: player });
    }

    changeTurn() {
        var countersUsed = this.state.countersUsed + 1;
        this.setState({ countersUsed: countersUsed });
        if (countersUsed >= this.state.maxCounters) {
            this.setState({ phase: "outofturns" });
        } else {
            if (this.state.allGreensFinishedForPlayer == 0)
                this.setState({ phase: "guessing", turn: this.state.turn == 1 ? 2 : 1 });
            else
                this.setState({ phase: "guessing", turn: this.state.allGreensFinishedForPlayer == 1 ? 2 : 1 });
        }
    }

    reportSelectingColor(selectedCard) {
        if (this.state.phase !== "guessing")
            return;
        this.setState({ phase: "settingColor", selectedCard: selectedCard });
    }



  renderwordsTable(words) {
      return (
          <div className="fullgameoffline">
              <OfflinePlayerControls player="1" getPhaseFunc={this.getPhase} getCurrentHintTurnFunc={this.getCurrentHintTurn} giveHintFunc={this.giveHint} getBoardStateFunc={this.getState} concedeTurnAction={this.concedeTurn} markAllGreensFinishedFunc={this.markAllGreensFinishedForHintingPlayer} isButtonDisabled={this.state.isButtonDisabled} />
              <div className="offgameboard" ref={this.gameboardRef}>
                  {words.map(w =>
                      <GameCard word={w} clickableCheck={this.isCardClickable} getHintingTurnFunc={this.getCurrentHintTurn} stateReporter={color => this.reportCardState(color)} colorSelectionReporter={this.reportSelectingColor} />
                  )}
              </div>
              <OfflinePlayerControls player="2" getPhaseFunc={this.getPhase} getCurrentHintTurnFunc={this.getCurrentHintTurn} giveHintFunc={this.giveHint} getBoardStateFunc={this.getState} concedeTurnAction={this.concedeTurn} markAllGreensFinishedFunc={this.markAllGreensFinishedForHintingPlayer} isButtonDisabled={this.state.isButtonDisabled} />
          </div>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderwordsTable(this.state.words);

    return (
      <div>
        {contents}
      </div>
    );
  }

  async populateWordsData() {
      const response = await fetch('wordrandomization/' + this.props.match.params.wordset);
    const data = await response.json();
    this.setState({ words: data, loading: false });
  }
}
